export default __webpack_public_path__ + "static/media/travelLogLogo.6d97f6ff.jpg";